import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloudOffIcon from '@material-ui/icons/CloudOff';
import copy from 'copy-to-clipboard';

const copy2Clipboard = (text) => {
    copy(text);
    alert('Has been copied: \n' + text)
}

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});

export default function StickyHeadTable({columns, rows, totalItems, setRowsPerPageM, setPageM, pageM, config, retrieve}) {
    const classes = useStyles();
    // const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleChangePage = (event, newPage) => {
        // setPage(newPage);
        console.log(newPage)
        setPageM(newPage)
        // fetchData();
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setRowsPerPageM(+event.target.value);
        // setPageM(0);
    };
    const cellRenderer = (column, value, maxWidth) => {
        return (

            <TableCell key={column.id} align={column.align}
                       style={{padding: 6,
                           minWidth: maxWidth}}>
            {column.format && typeof value === 'number' ? column.format(value) : value}
            </TableCell>
        );
    };
    const cellRendererA = (value, maxWidth) => {
        return (
            <TableCell
                key={value + Math.random()}
                style={{
                    padding: 6,
                    maxWidth: maxWidth,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'}}
            >
                <a target='_blank' href={value}>{value}</a>
                <FileCopyOutlined style={{width: 15, cursor: 'pointer',
                    height: 15,
                    marginLeft: 5}} onClick={() => copy2Clipboard(value)}/>
            </TableCell>
        );
    };
    const cellRendererAddress = ({ cellData, columnIndex }) => {
        const { columns, classes, rowHeight, onRowClick } = this.props;
        return (
            <TableCell
                component="a"
                href={config.exploreUrl + 'address/' + cellData}
                target='_blank'
                style={{ height: rowHeight, cursor: 'pointer' }}
                align={(columnIndex != null && columns[columnIndex].numeric) || false ? 'right' : 'left'}
            >
                {cellData}
            </TableCell>
        );
    };
    const cellRendererHash = (value, maxWidth) => {
        return (
            <TableCell
                key={value}
                style={{
                    padding: 6,
                    maxWidth: maxWidth,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'}}
            >
                <a target='_blank' href={config.exploreUrl + 'txs/' + value}>{value}</a>
            </TableCell>
        );
    };

    const cellRendererRetrieve = (row, maxWidth) => {
        // console.log(row.status,  row.status !== 'Expired')
        return (
            row.status === 'Expired' ? <TableCell
                component="div"
                onClick={() => retrieve(row)}
                key={Math.random()}
                style={{ maxWidth: maxWidth, cursor: 'pointer', border: 'none' }}
            >
                <CloudDownloadIcon/>
            </TableCell> :
                <TableCell
                    component="div"
                    key={Math.random()}
                    style={{ maxWidth: maxWidth, cursor: 'pointer', border: 'none' }}
                >
                    <CloudOffIcon/>
                </TableCell>
        );
    };
    React.useEffect(() => {
        // setRowsPerPageM(rowsPerPage)
    }, [])
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                    size={'small'}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                        const {retrieve, link, address, hash, maxWidth} = column
                                        const value = row[column.id];
                                        // console.log(column, hash)
                                        return (
                                            link ? cellRendererA(value, maxWidth) : (address ? cellRendererAddress(value, maxWidth) : (hash ? cellRendererHash(value, maxWidth) :
                                                    (retrieve ? cellRendererRetrieve(row, maxWidth) : cellRenderer(column, value, maxWidth))))

                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100]}
                component="div"
                count={totalItems}
                rowsPerPage={rowsPerPage}
                page={pageM}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Paper>
    );
}
